module.exports = __webpack_public_path__ + "img/voting-up-voted.cd17cecb.svg";